function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "f84d6772-5b9b-4066-a4f0-80beaf40aad3",
  "data-name": "Combined-Shape",
  className: "ac8a5127-c29e-419f-acd4-ad92f7966207",
  d: "M30,15A15,15,0,1,1,15,30,15,15,0,0,1,30,15Zm0,7.66h-.1a1,1,0,0,0-.92,1V29H23.7a1,1,0,0,0-1,1.06,1,1,0,0,0,.3.72l.1.09a1.09,1.09,0,0,0,.64.21H29V36.3a1,1,0,0,0,1,1h.12a1,1,0,0,0,.92-1V31l5.25,0a1,1,0,1,0,0-2.07H31V23.57a1,1,0,0,0-.93-.91Z"
});

var SvgIconPlus = function SvgIconPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return _ref2;
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-plus.f5d6ff0c.svg";
export { ForwardRef as ReactComponent };